import React, { useState } from "react";
import { SearchBars, Tabbles } from "../../../components";
import { PiBinoculars, PiFirstAidLight, PiTrash } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FiEdit } from "react-icons/fi";
import { actionDoctor } from "../../../redux/actions";
import { useAlert, useSnackBar } from "../../../contexts";
import { useNavigate } from "react-router-dom";

const MessageHistory = ({ loginData, setActiveTab }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const { showSnackBar } = useSnackBar();
    const dispatch = useDispatch();
    const [dateRange, setDateRange] = useState([null, null]);
    const [search, setSearch] = useState("");
    const getMassMessagesData = useSelector(
        (state) => state.doctor.getMassMessagesData?.data
    );
    const handleDateRangeChange = (range) => {
        setDateRange(range);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const suffix = (day) => {
            if (day > 3 && day < 21) return "th";
            switch (day % 10) {
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        };
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        return `${day}${suffix(day)} ${month} ${year}`;
    };

    const onSearchClick = () => { };

    const handleDeleteMessage = (msg) => {
        const credentials = {
            massMessageSetGuid: msg.massMessageGuid,
            isDeleted: true,
        };
        dispatch(
            actionDoctor.postCreateMassMessage(credentials, (error, response) => {
                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach((validationError) => {
                                    console.error(
                                        `${t("Field")}: ${validationError.Field} - ${t(
                                            "Message"
                                        )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                        "danger",
                                        validationError.Message,
                                        `${t("Error")} : ${validationError.Field}`
                                    );
                                });
                            } else {
                                showAlert(
                                    "danger",
                                    `${t("Invalid_credentials")}`,
                                    `${t("Error")} !`
                                );
                            }
                        } else {
                            showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
                        }
                    }
                } else if (response) {
                    dispatch(actionDoctor.getMassMessages(loginData.userGuid));
                    if (response.status === 200) {
                        showSnackBar(
                            `${t("doctor.Mass_Messages.message_deleted_successfully")}`,
                            "snackbar-success"
                        );
                    }
                }
            })
        );
    };
    return (
        <>
            <SearchBars.SearchBar
                className="search-bar"
                showDate={true}
                datepickermd={3}
                searchColmd={7}
                buttonColmd={2}
                searchCollg={8}
                buttonCollg={1}
                searchGrpClassName="form-group1"
                searchPlaceholder={t("Search")}
                cDateRangePlaceholder={t("select_date")}
                cDateRangeClassname="custom-date-range-picker"
                buttonClassname="btn-solid-Aqua_Teal"
                buttonChildren={<PiBinoculars className="bionCularIcon" />}
                dateRange={dateRange}
                searchValue={search}
                onDateRangeChange={handleDateRangeChange}
                onSearchChange={(e) => setSearch(e.target.value)}
                onSearchClick={onSearchClick}
            />

            <Tabbles.TableBlk
                headerIcon={<PiFirstAidLight className="header-Icn" />}
                heading={t("doctor.Mass_Messages.message_history")}
                columns={[
                    `${t("sent_date")}`,
                    `${t("email")} ${t("Subject")}`,
                    `${t("Edit")}`,
                    `${t("delete")}`,
                ]}
                data={getMassMessagesData?.result?.map((msg) => ({
                    [t("sent_date")]: formatDate(msg.createdDate),
                    [`${t("email")} ${t(
                        "Subject"
                    )}`]: `${msg.title} - ${msg.description}`,
                    [t("Edit")]: (
                        <div className="editBlkIcon">
                            <FiEdit
                                onClick={() => {
                                    setActiveTab("compose-message");
                                    navigate("/doctor/mass-messages/compose-message", {
                                        state: { msg: msg },
                                    });
                                }}
                                className="editIcon"
                            />
                        </div>
                    ),
                    [t("delete")]: (
                        <PiTrash
                            onClick={() => handleDeleteMessage(msg)}
                            className="delIcon noVerify"
                        />
                    ),
                }))}
                tabbleSectionClassname="tabble-message-history"
                tabbleClassname="tabble "
            />
        </>
    );
};

export default MessageHistory;
